import {
  Add,
  ArrowBack,
  ArrowForward,
  Close,
  Remove,
} from "@mui/icons-material";
import {
  AppBar,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  styled,
  TextField,
  Toolbar,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FsLightbox from "fslightbox-react";
import MoveToTop from "../MoveToTop";

const ItemsBox = styled(Box)(({ theme }) => ({
  minWidth: "600px",
  borderBottom: "1px solid #999",
  padding: "10px 0px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  [theme.breakpoints.down('md')]: {
    gap: "15px"
  },
}));

const ItemsBox1 = styled(Box)(({ theme }) => ({
  minWidth: "600px",
  borderBottom: "1px solid #999",
  background: "#1976d2",
  color: "#f5f5f5",
  padding: "10px 0px",
  display: "flex",
  alignItems: "left",
  justifyContent: "space-around",
  [theme.breakpoints.down('md')]: {
    gap: "15px"
  },
}));

const OptionContiner = styled(Card)(({ theme }) => ({
  // margin: "0 10%",
  minWidth: "80%",
  margin: "0 20px",
  "& h3": {
    margin: "0",
    // paddingLeft:"15px",
    // paddingTop:"20px",
    padding: "15px",
    fontWeight: "400",
    borderBottom: "1px solid #999",
  },
  [theme.breakpoints.down('md')]: {
    overflowX: "scroll",
  }
}));

const ImageBox = styled(Box)(({ theme }) => ({
  marginLeft: "20px",
  marginBottom: "30px",
  display: "flex",
  alignItems: "left",
  "& span": {
    fontSize: "22px",
    marginLeft: "20px",
  },
  "& img": {
    width: "100px",
    height: "80px",
    objectFit: "contain",
    borderRadius: "10px",
  },
  [theme.breakpoints.down('md')]: {
    marginLeft: "0",
    marginBottom: "10px",
    marginTop: "10px"
  },
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: "20px",
  [theme.breakpoints.down('md')]: {
    padding: "0"
  },
}))

const ProductCode = styled(Box)(({ theme }) => ({
  width: "80px",
  // marign: "0 10px",
}));

const ProductName = styled(Box)(({ theme }) => ({
  width: "460px",
  paddingLeft: "40px",
  marignLeft: "20px",
  textAlign: "left"
}));



const ProductColor = styled(Box)(({ theme }) => ({
  width: "100%",
  //color: "#999",
  padding: "10px 10px",
  display: "flex",
  alignItems: "left",
}));
const ProductSize = styled(Box)(({ theme }) => ({
  width: "160px",

  // marign: "0 10px",
}));


const ProductPrice = styled(Box)(({ theme }) => ({
  width: "180px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  //marign: "0 10px",
}));

const ProductLocation = styled(Box)(({ theme }) => ({
  width: "100px",
  color: "#999",
  // marign: "0 10px",
}));

const QuantityBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "200px",
}));

const QuantityBox1 = styled(Box)(({ theme }) => ({
  minWidth: '180px',
}));

const ButtonDiv = styled(Box)(({ theme }) => ({
  marginLeft: "20px",
  marginRight: "5px",
  textAlign: "center",
  width: "260px",
}));

// const ImageBox = styled(Box)(({ theme }) => ({
//   marginRight: "20px",
//   "& img": {
//     width: "100px",
//     height: "80px",
//     objectFit: "cover",
//     borderRadius: "10px",
//   },
// }));

// const demoList = [
 
// ];

const OptionDialog = ({
  sendOption,
  viewOptionDetails,
  handleAdd,
  handleSubstract,
  handleQuantity,
  handleAddToCart,
  customerDetails,
  singleLoading,
  trigger,
  setTrigger,
}) => {
  const [dialogDetails, setDialogDetails] = useState({
    open: true,
    refetch: false,
    WEBSKU: "",
    ColourID: "",
  });

  const [toggler, setToggler] = useState(false);
  const [image, setImage] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);


  useEffect(() => {
    if (trigger === true) {
      setTimeout(() => {
        handleClose();
      }, 500);
    }
  }, [trigger]);

  useEffect(() => {
    sendOption(dialogDetails);
  }, [dialogDetails]);

  useEffect(() => {
    let intervalId;

    const handleRefetch = () => {

      setDialogDetails({
        open: true,
        refetch: true,
        WEBSKU: viewOptionDetails[0][0]?.WEBSKU,
        ColourID: viewOptionDetails[0][0]?.ColourID,
      });

      setTimeout(() => {
        setDialogDetails({
          open: true,
          refetch: false,
          WEBSKU: "",
          ColourID: "",
        });
      }, 100);
    };

    if (viewOptionDetails) {
      intervalId = setInterval(handleRefetch, 30000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [viewOptionDetails]);


  //console.log("dialogue-details", dialogDetails);
  // console.log("view-option-details", viewOptionDetails);


  const handleClickPrev = (currentSlide) => {
    setImage(viewOptionDetails[currentSlide][0].imageUrl);
    setCurrentIndex(currentSlide);
  };
  //console.log("image", image)

  const handleClickNext = (currentSlide) => {
    setImage(viewOptionDetails[currentSlide][0].imageUrl);
    setCurrentIndex(currentSlide);
  };

  function SampleNextArrow(props) {

    const { className, style, onClick, currentSlide } = props;
    handleClickNext(currentSlide);
    const handleClick = () => {
      onClick();
      // handleClickNext(currentSlide);
    };
    return (
      <IconButton
        onClick={handleClick}
        style={{ position: "absolute", right: "20px", top: "-80px" }}
      >
        <ArrowForward />
      </IconButton>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick, currentSlide } = props;
    handleClickPrev(currentSlide);

    const handleClick = () => {
      onClick();
      // handleClickPrev(currentSlide);
    };

    return (
      <IconButton
        onClick={handleClick}
        style={{ position: "absolute", right: "70px", top: "-80px" }}
      >
        <ArrowBack />
      </IconButton>
    );
  }

  const settings = {
    dots: viewOptionDetails.length > 1,
    infinite: viewOptionDetails.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const handleClose = () => {
    setDialogDetails({
      open: false,
    });
  };


  // console.log("view optionss", viewOptionDetails)
  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = "https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png";
  }


  return (
    <>
      <MoveToTop />
      <Dialog fullScreen open={dialogDetails.open} onClose={handleClose}>

        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <h4>{viewOptionDetails[0] ? viewOptionDetails[0][0]?.ItemName : null}</h4>
            <IconButton
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              style={{ position: "absolute", right: "0" }}
            >
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>

        <StyledDialogContent>
          <FsLightbox
            toggler={toggler}
            sources={[image ? image : viewOptionDetails[0] && viewOptionDetails[0][0]?.imageUrl ? viewOptionDetails[0][0]?.imageUrl : "https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png"]}
            type="image"
          //sourceIndex={currentIndex}
          />

          <Container maxWidth={viewOptionDetails.length === 1 ? "xl" : false}>


            <ImageBox onClick={() => setToggler(!toggler)}>
              {image ? (
                <img
                  src={image}
                  // alt={viewOptionDetails ? viewOptionDetails[0][0]?.ItemName : null}
                  onError={handleImageError}
                />
              ) : viewOptionDetails[0] && viewOptionDetails[0][0]?.imageUrl ? (
                <img
                  src={viewOptionDetails[0][0]?.imageUrl}
                  onError={handleImageError}
                />
              ) : (
                <img
                  src="https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png"
                  alt="Placeholder"
                />
              )}

              <span>{viewOptionDetails[0] ? viewOptionDetails[0][0]?.ItemName : null}</span>
            </ImageBox>

            {/* <Slider {...settings}> */}

            <div>
              {singleLoading ? (
                <Grid item xs={12}>
                  <Box textAlign={"center"} margin={"40px"}>
                    <CircularProgress />
                  </Box>
                </Grid>
              ) : (
                <Slider {...settings}>
                  {Object.entries(viewOptionDetails).map(([color, products]) => (

                    <div key={color}>

                      <OptionContiner>
                        <ProductColor> Colour: {viewOptionDetails[color][0].ColourName.replace(/_/g, ' ').replace(/\//g, ' ')}</ProductColor>


                        <ItemsBox1>
                          <ProductName>Name</ProductName>
                          {/* <ProductColor>Color</ProductColor> */}
                          <ProductSize>Size</ProductSize>
                          <ProductSize>SOH</ProductSize>
                          <ProductPrice>Price</ProductPrice>
                          <QuantityBox1></QuantityBox1>
                          <ButtonDiv></ButtonDiv>

                        </ItemsBox1>

                        {products.map((product, index) => (
                          <>
                            <ItemsBox key={product.id}>


                              <ProductName> {product.ItemName}</ProductName>


                              {/* <ProductColor> {product.ColourName.replace(/_/g, ' ').replace(/\//g, ' ')}</ProductColor> */}
                              <ProductSize> {product.SizeID}</ProductSize>
                              <ProductSize> {product.stocks?.Stock}</ProductSize>
                              {/* <ProductLocation>{product.DefaultStore}</ProductLocation> */}
                              <ProductPrice>${product.RetailSalesPrice}</ProductPrice>

                              <QuantityBox>
                                <IconButton onClick={() => handleSubstract(product.productID)}>
                                  <Remove />
                                </IconButton>
                                <TextField
                                  name="quantity"
                                  type="number"
                                  variant="outlined"
                                  //disabled ={product.stocks?.Stock === "0"}
                                  value={
                                    customerDetails.quantity[product.productID] === 0
                                      ? 0
                                      : customerDetails.quantity[product.productID] || 1
                                  }
                                  onChange={(e) => handleQuantity(e, product.productID, product.stocks?.Stock)}
                                  style={{ width: "100px" }}
                                />
                                <IconButton
                                  //disabled ={product.stocks?.Stock === "0"} 
                                  onClick={() => handleAdd(product.productID, product.stocks?.Stock)}>
                                  {" "}
                                  <Add />{" "}
                                </IconButton>
                              </QuantityBox>

                              <ButtonDiv>
                                <Button
                                  size="medium"
                                  color="primary"
                                  variant="contained"
                                  disabled={product.stocks === null || product.stocks === undefined || product.stocks?.Stock === "0" || product.stocks?.Stock < 0}
                                  onClick={() => handleAddToCart(
                                    //product.id,
                                    product.productID,
                                    product.SchoolID,
                                    product.ItemName,
                                    product.ColourName,
                                    product.SizeID,
                                    product.ColourID,
                                    product.RetailSalesPrice,
                                    product.imageUrl,
                                    product.WEBSKU,
                                  )}
                                >
                                  Add To Cart
                                </Button>
                              </ButtonDiv>
                            </ItemsBox>
                          </>

                        ))}
                      </OptionContiner>
                    </div>


                  ))}
                </Slider>
              )}
            </div>

            {/* </Slider> */}
          </Container>
        </StyledDialogContent>
      </Dialog>
    </>
  );
};

export default OptionDialog;
